<template>
  <div class="main-progress-bar-and-cumbe-box-container">
    <div class="progress-bar-container" :class="{'is-updating' : IsUpdating}">
      <div class="track" :style="{height : FillingHeight}">
        <div
          class="filling"
          :class="ProgressHeaderText"
          ref="filling"
          :style="{width : WidthRule , height : FillingHeight , backgroundColor : Color }"
        ></div>
      </div>
    </div>
    <CubeBox ref="Cube" :Width="70" :Height="70" />
  </div>
</template>

<script>
import CubeBox from "./CubeBox";

export default {
  props: ["value", "FillingWidth", "Color"],
  components: {
    CubeBox,
  },
  data: function () {
    return {
      Width: 0,
      IsUpdating: false,
      ProgressHeaderText: "",
      routes: null,
    };
  },
  mounted: function () {
    this.routes = require("../routing/routes").default;

    if (this.value >= 0 && this.value <= 100) {
      this.Width = this.value + "%";
    }

    // for first entered page navigation guards won't run
    // this to update route progress manually
    this.updateProgress(this.$route);

    // configure navigation hooks to update progress value
    this.$router.beforeEach((to, from, next) => {
      this.updateProgress(to);
      next();
    });
  },

  methods: {
    updateProgress: function (targetRoutePath) {
      // update header text
      var targetRoutePathName = targetRoutePath.fullPath.replace("/", "");

      // start moving the cube after 1.5 second
      let me = this;
      setTimeout(() => {
        if (me.$refs.Cube) me.$refs.Cube.MoveCubeTo(targetRoutePathName);
      }, 1500);

      this.ProgressHeaderText = targetRoutePathName;

      var currentRoute = this.routes.find(
        (item) => item.path === targetRoutePath.fullPath
      );
      if (currentRoute) this.Width = currentRoute.progress;
    },
  },

  computed: {
    FillingHeight: function () {
      if (!this.FillingWidth) {
        return "5px";
      }
      return this.FillingWidth + "px";
    },
    WidthRule: function () {
      return this.Width + "%";
    },
  },
  watch: {
    value: function (newValue) {
      if (newValue >= 0 && newValue <= 100) {
        this.Width = this.value + "%";
      }
    },
  },
};
</script>

<style>
.track {
  padding: 0px;
  width: 100vh;
  position: fixed;
  top: -10px;
  -webkit-transform: rotate(90deg);
  -webkit-transform-origin: bottom left;
  -moz-transform: rotate(90deg);
  -moz-transform-origin: bottom left;
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  z-index: 9999999;
}

.filling {
  position: absolute;
  top: 0px;
  left: 0px;
  background-color: #aacbec;
  transition: width 0.7s ease;
  -webkit-transition: width 2s;
  -o-transition: width 2s;
  transition: width 2s;
  border-top-right-radius: 25px;
  border-bottom-right-radius: 25px;
}

.filling::before {
  content: "";
  position: absolute;
  bottom: 3px;
  right: 1px;
  font-size: 16px;
  color: #aacbec;
}

.filling.home::before {
  content: "Home";
}

.filling.achievements::before {
  content: "Achievements";
}

.filling.tools::before {
  content: "Tools";
}

.filling.about::before {
  content: "About";
}

.filling.contact::before {
  content: "Contact";
  right: 73px;
}
</style>